/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import { useMapContext } from '../../context/map-context';

export const RestoreSavedView = (): null => {
  const map = useMap();
  const { savedViewState, facilityKey } = useMapContext();
  const appliedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!facilityKey || !savedViewState) return;
    if (appliedKeyRef.current === facilityKey) return;

    const [lat, lng] = savedViewState.pan || [];
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

    map.setView([lat, lng], savedViewState.zoom || map.getZoom(), { animate: false });
    appliedKeyRef.current = facilityKey;
  }, [savedViewState, facilityKey, map]);

  return null;
};
